import React, { useState, useEffect, useMemo } from 'react';
import { Clock, Trophy, Play, Upload, Download, Plus, Edit2, Trash2, Save, X } from 'lucide-react';
import axios from 'axios';

//const API_URL = 'http://localhost:8000';
//const API_URL = 'https://quizapp-production-7dbf.up.railway.app';
//const API_URL = 'http://51.20.124.165:8000';
const API_URL = 'https://quizappbackend.sababozpolat.com';

const App = () => {

	const [ws, setWs] = useState(null);
	const [userId, setUserId] = useState(null);
	const [view, setView] = useState('landing');
	const [email, setEmail] = useState('');
	const [code, setCode] = useState('');
	const [gamePin, setGamePin] = useState('');
	const [playerName, setPlayerName] = useState('');
	const [studentId, setStudentId] = useState('');
	const [quizData, setQuizData] = useState(null);
	const [currentQuestion, setCurrentQuestion] = useState(0);
	const [timeLeft, setTimeLeft] = useState(30);
	const [selectedAnswer, setSelectedAnswer] = useState(null);
	const [isHost, setIsHost] = useState(false);
	const [waitingForNext, setWaitingForNext] = useState(false);
	const [showLeaderboard, setShowLeaderboard] = useState(false);
	const [editingQuiz, setEditingQuiz] = useState(null);
	const [editingQuestion, setEditingQuestion] = useState(null);
	const [questionForm, setQuestionForm] = useState({
	question: '', code: '', options: ['', '', '', ''], correctAnswer: 0, timeLimit: 30
	});
	// En üste state ekle (diğer state'lerin yanına)
	const [codeSent, setCodeSent] = useState(false);
	const [gameStarted, setGameStarted] = useState(false);
	const [answeredCount, setAnsweredCount] = useState(0);
	const [totalPlayers, setTotalPlayers] = useState(0);
	const [countdown, setCountdown] = useState(null);
	const [playersList, setPlayersList] = useState([]);
	const [leaderboard, setLeaderboard] = useState([]);
	
	const marmaraBlue = '#003D72';
	const marmaraLightBlue = '#0071CE';
	const marmaraGray = '#A8A8AA';

	const shuffledOptions = useMemo(() => {
		if (!quizData || !quizData.questions[currentQuestion]) return [];
		const question = quizData.questions[currentQuestion];
		const shuffled = question.options.map((opt, idx) => ({ 
			text: opt, 
			originalIndex: idx 
		}));
		for (let i = shuffled.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * (i + 1));
			[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
		}
		return shuffled;
	}, [currentQuestion, quizData]);

	useEffect(() => {
	if (view === 'game' && timeLeft > 0) {
	  const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
	  return () => clearTimeout(timer);
	}
	}, [view, timeLeft]);

	useEffect(() => {
	  if ((view === 'game' || view === 'presentation') && timeLeft > 0 && countdown === null) {
		const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
		return () => clearTimeout(timer);
	  }
	  
	  // YENİ: Süre bitince otomatik cevap gönder
	  if (view === 'game' && timeLeft === 0 && !isHost && selectedAnswer === null && !waitingForNext) {
		// Otomatik 0 puan cevabı gönder
		const autoSubmit = async () => {
		  try {
			await axios.post(`${API_URL}/answer`, {
			  game_pin: gamePin,
			  user_id: userId,
			  question_index: currentQuestion,
			  answer_index: -1,  // -1 = cevap verilmedi
			  time_left: 0
			});
		  } catch (error) {
			console.error('Otomatik cevap gönderme hatası:', error);
		  }
		  
		  setWaitingForNext(true);
		  setShowLeaderboard(true);
		};
		
		autoSubmit();
	  }
	}, [view, timeLeft, countdown, isHost, selectedAnswer, waitingForNext, gamePin, userId, currentQuestion]);

	useEffect(() => {
	  if (countdown !== null && countdown > 0) {
		const timer = setTimeout(() => {
		  setCountdown(countdown - 1);
		}, 1000);
		return () => clearTimeout(timer);
	  } else if (countdown === 0) {
		setCountdown(null);
		setGameStarted(true);
		setTimeLeft(quizData.questions[currentQuestion].timeLimit);  // BUNU EKLE
	    if (view !== 'presentation') {  // Presentation'daysa view değiştirme
		  setView('game');
		}
	  }
	}, [countdown, currentQuestion, quizData, view]);

	useEffect(() => {
	  const urlParams = new URLSearchParams(window.location.search);
	  const presentationPin = urlParams.get('presentation');
	  
	  if (presentationPin) {
		setGamePin(presentationPin);
		setView('presentation');
		
		// Quiz verisini backend'den çek
		const fetchQuizData = async () => {
		  try {
			const response = await axios.get(`${API_URL}/game/${presentationPin}/quiz`);
			setQuizData(response.data.quiz_data);
		  } catch (error) {
			console.error('Quiz verisi alınamadı:', error);
		  }
		};
		fetchQuizData();
		
		const fetchPlayers = async () => {
			try {
			  const response = await axios.get(`${API_URL}/game/${presentationPin}/players`);
			  console.log('📊 Mevcut oyuncular:', response.data);
			  setPlayersList(response.data.players);
			  setTotalPlayers(response.data.total_players);
			} catch (error) {
			  console.error('Oyuncu listesi alınamadı:', error);
			}
		};
		fetchPlayers();  // BUNU EKLE
		
		// WebSocket bağlan
		//const websocket = new WebSocket(`ws://localhost:8000/ws/${presentationPin}/presentation`);
		const websocket = new WebSocket(`wss://quizappbackend.sababozpolat.com/ws/${presentationPin}/presentation`);
		websocket.onmessage = (event) => {
		  const message = JSON.parse(event.data);
		  console.log('Presentation WebSocket:', message);
		  
		  if (message.type === 'player_joined') {
			setPlayersList(message.players);
			setTotalPlayers(message.total_players);
		  }
		  
		  if (message.type === 'start_game') {
			setGameStarted(true);
			setCountdown(3);
		  }
		  
		  if (message.type === 'next_question') {
			setCurrentQuestion(message.question_index);
			setTimeLeft(message.time_limit);
			setAnsweredCount(0);
		  }
		  
		  if (message.type === 'answer_submitted') {
			setLeaderboard(message.leaderboard);
			setAnsweredCount(message.answered_count);
			setTotalPlayers(message.total_players);
		  }
		  
		  if (message.type === 'show_results') {
			setView('presentation-results');
		  }
		};
		
		setWs(websocket);
	  }
	}, []);

	const downloadFile = (content, filename, type) => {
	const blob = new Blob([content], { type });
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
	};

	const createNewQuiz = () => {
	setEditingQuiz({ title: '', defaultTimeLimit: 30, questions: [] });
	setView('quizEditor');
	};

	const addQuestion = () => {
	if (!questionForm.question || questionForm.options.some(opt => !opt)) {
	  alert('Lütfen soru ve tüm seçenekleri doldurun.');
	  return;
	}
	setEditingQuiz({ ...editingQuiz, questions: [...editingQuiz.questions, { ...questionForm }] });
	setQuestionForm({ question: '', code: '', options: ['', '', '', ''], correctAnswer: 0, timeLimit: editingQuiz.defaultTimeLimit });
	};

	const Logo = () => (
	<div className="w-24 h-24 mx-auto mb-4 bg-white rounded-full flex items-center justify-center shadow-lg">
	  <svg viewBox="0 0 100 100" className="w-20 h-20">
		<circle cx="50" cy="50" r="45" fill={marmaraBlue} />
		<text x="50" y="65" textAnchor="middle" fill="white" fontSize="48" fontWeight="bold" fontFamily="serif">M</text>
	  </svg>
	</div>
	);

if (countdown !== null) {
  console.log('🔴 COUNTDOWN EKRANI RENDER EDİLİYOR, countdown:', countdown);
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: `linear-gradient(135deg, ${marmaraBlue} 0%, ${marmaraLightBlue} 100%)` }}>
      <div className="text-center">
        <div className="text-white text-9xl font-bold mb-8 animate-pulse">
          {countdown}
        </div>
        <div className="text-white text-3xl font-semibold">
          Oyun Başlıyor...
        </div>
      </div>
    </div>
  );
}

if (view === 'landing') {
	return (
	  <div className="min-h-screen flex items-center justify-center p-4" style={{ background: `linear-gradient(135deg, ${marmaraBlue} 0%, ${marmaraLightBlue} 100%)` }}>
		<div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
		  <div className="text-center mb-8">
			<Logo />
			<h1 className="text-3xl font-bold" style={{ color: marmaraBlue }}>Marmara Quiz</h1>
			<p className="text-gray-600 mt-2">Marmara Üniversitesi</p>
		  </div>
		  <div className="space-y-4">
			<button onClick={() => setView('hostLogin')} className="w-full text-white py-3 rounded-lg font-semibold hover:opacity-90 transition" style={{ backgroundColor: marmaraBlue }}>Host Girişi</button>
			<button onClick={() => setView('playerJoin')} className="w-full text-white py-3 rounded-lg font-semibold hover:opacity-90 transition" style={{ backgroundColor: marmaraLightBlue }}>Katılımcı Girişi</button>
		  </div>
		</div>
	  </div>
	);
}

if (view === 'presentation') {
  return (
    <div className="min-h-screen p-8" style={{ background: `linear-gradient(135deg, ${marmaraBlue} 0%, ${marmaraLightBlue} 100%)` }}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-2xl p-6 mb-6 text-center">
          <h1 className="text-5xl font-bold mb-2" style={{ color: marmaraBlue }}>Marmara Quiz</h1>
          <div className="text-3xl font-bold" style={{ color: marmaraLightBlue }}>PIN: {gamePin}</div>
        </div>
        
        {/* Katılımcı Listesi veya Soru veya Results */}
        {!gameStarted ? (
          // Lobby - Katılımcı Listesi
          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <h2 className="text-3xl font-bold mb-6 text-center" style={{ color: marmaraBlue }}>
              Katılımcılar ({playersList.length})
            </h2>
            <div className="grid grid-cols-3 gap-4">
              {playersList.map((player, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-4 text-center">
                  <div className="font-semibold text-xl" style={{ color: marmaraBlue }}>{player.name}</div>
                  <div className="text-sm text-gray-600">{player.student_id}</div>
                </div>
              ))}
            </div>
          </div>
        ) : quizData && currentQuestion < quizData.questions.length ? (
          // Oyun - Soru Gösterimi
          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <div className="flex justify-between items-center mb-6">
              <div className="text-xl text-gray-600">Soru {currentQuestion + 1} / {quizData.questions.length}</div>
              <div className="flex items-center gap-2 text-3xl font-bold text-red-600">
                <Clock className="w-8 h-8" />{timeLeft}s
              </div>
            </div>
            
            <h2 className="text-3xl font-bold mb-6" style={{ color: marmaraBlue }}>
              {quizData.questions[currentQuestion].question}
            </h2>
            
            {quizData.questions[currentQuestion].code && (
              <div className="bg-gray-900 text-gray-100 rounded-lg p-6 mb-6 font-mono text-lg overflow-x-auto">
                <pre>{quizData.questions[currentQuestion].code}</pre>
              </div>
            )}
            
            <div className="grid grid-cols-2 gap-4 mb-6">
              {quizData.questions[currentQuestion].options.map((option, index) => {
                const colors = ['#E74C3C', '#3498DB', '#F39C12', '#2ECC71'];
                return (
                  <div 
                    key={index} 
                    className="p-6 rounded-lg text-white font-bold text-2xl text-center"
                    style={{ backgroundColor: colors[index] }}
                  >
                    {option}
                  </div>
                );
              })}
            </div>
            
            {/* Cevaplayan Sayısı */}
            <div className="bg-blue-50 rounded-lg p-6 text-center">
              <div className="text-4xl font-bold" style={{ color: marmaraBlue }}>
                {answeredCount} / {totalPlayers}
              </div>
              <div className="text-xl text-gray-600 mt-2">Cevaplayan</div>
            </div>
          </div>
        ) : (
          // Results - Podyum (results view'ındaki gibi)
          <div className="bg-white rounded-2xl shadow-2xl p-8">
            <h2 className="text-4xl font-bold mb-8 text-center" style={{ color: marmaraBlue }}>🏆 Final Sıralaması 🏆</h2>
            {/* Buraya results ekranındaki podyum kodunu kopyala */}
			<div className="space-y-4 mb-6">
			  {/* Top 3 Podyum */}
			  <div className="space-y-4 mb-8">
				{leaderboard.slice(0, 3).map((player, index) => {
				  const gradients = [
					'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)', // Altın
					'linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)', // Gümüş
					'linear-gradient(135deg, #CD7F32 0%, #8B4513 100%)'  // Bronz
				  ];
				  const sizes = ['text-6xl', 'text-4xl', 'text-2xl'];
				  const paddings = ['p-8', 'p-6', 'p-4'];
				  const medals = ['🥇', '🥈', '🥉'];
				  
				  return (
					<div 
					  key={index} 
					  className={`rounded-2xl shadow-2xl ${paddings[index]} text-center transform hover:scale-105 transition`}
					  style={{ background: gradients[index] }}
					>
					  <div className="text-6xl mb-2">{medals[index]}</div>
					  <div className="text-white font-bold mb-2" style={{ fontSize: index === 0 ? '2rem' : index === 1 ? '1.5rem' : '1.2rem' }}>
						{player.name}
					  </div>
					  <div className="text-white opacity-90 text-sm mb-3">{player.student_id}</div>
					  <div className={`text-white font-bold ${sizes[index]}`}>
						{player.score}
					  </div>
					  <div className="text-white opacity-75 text-sm mt-1">puan</div>
					</div>
				  );
				})}
			  </div>
			  
			  {/* Divider */}
			  {leaderboard.length > 3 && (
				<div className="border-t-2 border-gray-300 my-6"></div>
			  )}
			  
			  {/* Geri kalan sıralama */}
			  {leaderboard.slice(3).map((player, index) => (
				<div key={index + 3} className="flex items-center justify-between bg-gray-50 p-4 rounded-lg">
				  <div className="flex items-center gap-4">
					<div className="text-2xl font-bold text-gray-400">#{index + 4}</div>
					<div>
					  <div className="font-semibold" style={{ color: marmaraBlue }}>{player.name}</div>
					  <div className="text-sm text-gray-600">{player.student_id}</div>
					</div>
				  </div>
				  <div className="text-2xl font-bold" style={{ color: marmaraLightBlue }}>{player.score}</div>
				</div>
			  ))}
			</div>
          </div>
        )}
      </div>
    </div>
  );
}

if (view === 'hostLogin') {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: `linear-gradient(135deg, ${marmaraBlue} 0%, ${marmaraLightBlue} 100%)` }}>
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-6" style={{ color: marmaraBlue }}>Host Girişi</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email (@marmara.edu.tr)</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  if (!codeSent) {
                    // Kod gönder
                    document.getElementById('send-code-btn').click();
                  } else {
                    // Doğrula
                    document.getElementById('verify-btn').click();
                  }
                }
              }}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
              placeholder="john.doe"
            />
          </div>
          {codeSent && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Doğrulama Kodu</label>
              <input 
                type="text" 
                value={code} 
                onChange={(e) => setCode(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    document.getElementById('verify-btn').click();
                  }
                }}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
                placeholder="123456" 
              />
            </div>
          )}
          <div className="flex gap-2">
            <button 
              onClick={() => setView('landing')} 
              className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition"
            >
              Geri
            </button>
            {!codeSent ? (
              <button
                id="send-code-btn"
                onClick={async () => {
                  // Validation
                  if (!email || email.trim() === '') {
                    alert('Lütfen email adresinizi girin');
                    return;
                  }
                  
                  try {
                    const fullEmail = email.includes('@') ? email : `${email}@marmara.edu.tr`;
                    await axios.post(`${API_URL}/host/login`, { email: fullEmail });
                    setCodeSent(true);
                    alert('Kod gönderildi');
                  } catch (error) {
                    alert('Hata: ' + (error.response?.data?.detail || 'Email gönderilemedi'));
                  }
                }} 
                className="flex-1 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition" 
                style={{ backgroundColor: marmaraBlue }}
              >
                Kod Gönder
              </button>
            ) : (
              <button
                id="verify-btn"
                onClick={async () => {
                  try {
                    const fullEmail = email.includes('@') ? email : `${email}@marmara.edu.tr`;
                    await axios.post(`${API_URL}/host/verify`, { email: fullEmail, code });
                    setIsHost(true);
                    setView('hostDashboard');
                  } catch (error) {
                    alert('Hata: ' + (error.response?.data?.detail || 'Geçersiz kod'));
                  }
                }} 
                className="flex-1 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition" 
                style={{ backgroundColor: marmaraBlue }}
              >
                Doğrula
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

if (view === 'hostDashboard') {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <h2 className="text-3xl font-bold mb-8" style={{ color: marmaraBlue }}>Host Dashboard</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <button onClick={createNewQuiz} className="border-2 border-dashed rounded-lg p-6 text-center hover:border-blue-600 transition" style={{ borderColor: marmaraGray }}>
              <Plus className="w-12 h-12 mx-auto mb-3" style={{ color: marmaraBlue }} />
              <h3 className="font-semibold text-gray-700">Yeni Quiz Oluştur</h3>
            </button>
            <button onClick={() => downloadFile(JSON.stringify({title:"Örnek Quiz",defaultTimeLimit:30,questions:[{question:"Python'da liste?",code:"my_list=[1,2,3]",options:["[]","{}","()","<>"],correctAnswer:0,timeLimit:30}]}, null, 2), 'quiz_template.json', 'application/json')} className="border-2 border-dashed rounded-lg p-6 text-center hover:border-blue-600 transition" style={{ borderColor: marmaraGray }}>
              <Download className="w-12 h-12 mx-auto mb-3" style={{ color: marmaraBlue }} />
              <h3 className="font-semibold text-gray-700">Şablon İndir</h3>
            </button>
            <div className="border-2 border-dashed rounded-lg p-6 text-center hover:border-blue-600 transition" style={{ borderColor: marmaraGray }}>
              <Upload className="w-12 h-12 mx-auto mb-3" style={{ color: marmaraBlue }} />
              <h3 className="font-semibold text-gray-700 mb-2">Quiz Yükle</h3>
              <input type="file" accept=".json" onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  const reader = new FileReader();
                  reader.onload = (event) => {
                    try {
                      setQuizData(JSON.parse(event.target.result));
                      alert('Quiz yüklendi');
                    } catch { alert('Geçersiz JSON'); }
                  };
                  reader.readAsText(file);
                }
              }} className="hidden" id="file-upload" />
              <label htmlFor="file-upload" className="text-sm cursor-pointer" style={{ color: marmaraLightBlue }}>JSON seç</label>
            </div>
          </div>
          {quizData && (
            <div className="rounded-lg p-6 mb-6" style={{ backgroundColor: '#E6F0F9' }}>
              <h3 className="font-bold text-lg mb-2" style={{ color: marmaraBlue }}>{quizData.title}</h3>
              <p className="text-gray-600">{quizData.questions.length} soru • {quizData.defaultTimeLimit}s</p>
            </div>
          )}
          <div className="flex gap-4">
            <button 
              onClick={async () => {
                if (!quizData) {
                  alert('Önce quiz yükle');
                  return;
                }
                try {
                  const response = await axios.post(`${API_URL}/game/start`, {
                    quiz_data: quizData,
                    host_email: email
                  });
                  const pin = response.data.game_pin;
                  setGamePin(pin);
                  
                  console.log('Oyun PIN:', pin);
                  console.log('WebSocket bağlanıyor...');
                  
                  // const websocket = new WebSocket(`ws://localhost:8000/ws/${pin}/host`);
				  const websocket = new WebSocket(`wss://quizappbackend.sababozpolat.com/ws/${pin}/host`);
				  websocket.onopen = () => {
                    console.log('WebSocket bağlandı!');
                  };
                  websocket.onerror = (error) => {
                    console.error('WebSocket hatası:', error);
                  };
                  websocket.onmessage = (event) => {
                    const message = JSON.parse(event.data);
                    console.log('Host WebSocket mesajı:', message);
                    
                    if (message.type === 'player_joined') {
                      console.log('Oyuncu katıldı, total:', message.total_players);
                      setPlayersList(message.players);
                      setTotalPlayers(message.total_players);
                    }

 				    if (message.type === 'start_game') {
				 	  setView('game');
				    }
                    
                    if (message.type === 'answer_submitted') {
					  console.log('📊 Leaderboard:', message.leaderboard);
					  setLeaderboard(message.leaderboard);
                      setAnsweredCount(message.answered_count);
                      setTotalPlayers(message.total_players);
                    }
                  };
                  setWs(websocket);
                  
                  alert(`Oyun PIN: ${pin}\nKatılımcılar bu kodu kullanabilir.`);
                  setIsHost(true);
                  setCurrentQuestion(0);
                  setAnsweredCount(0);
                  setTotalPlayers(0);
                  setGameStarted(false);
                  setView('lobby');
                } catch (error) {
                  console.error('Oyun başlatma hatası:', error);
                  alert('Hata: ' + (error.response?.data?.detail || 'Oyun başlatılamadı'));
                }
              }}
              disabled={!quizData} 
              className="flex-1 text-white py-4 rounded-lg font-bold hover:opacity-90 transition disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2" 
              style={{ backgroundColor: quizData ? '#00A651' : undefined }}
            >
              <Play className="w-5 h-5" />
              Oyunu Başlat
            </button>
            <button onClick={() => setView('landing')} className="px-6 bg-gray-200 text-gray-700 py-4 rounded-lg font-semibold hover:bg-gray-300 transition">Çıkış</button>
          </div>
        </div>
      </div>
    </div>
  );
}

if (view === 'quizEditor') {
	return (
	  <div className="min-h-screen bg-gray-50 p-4">
		<div className="max-w-6xl mx-auto">
		  <div className="bg-white rounded-2xl shadow-lg p-6 mb-4">
			<div className="flex items-center justify-between mb-6">
			  <h2 className="text-2xl font-bold" style={{ color: marmaraBlue }}>Quiz Editörü</h2>
			  <button onClick={() => { setView('hostDashboard'); setEditingQuiz(null); }} className="text-gray-600 hover:text-gray-800">
				<X className="w-6 h-6" />
			  </button>
			</div>
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
			  <div>
				<label className="block text-sm font-medium text-gray-700 mb-2">Quiz Başlığı</label>
				<input type="text" value={editingQuiz?.title || ''} onChange={(e) => setEditingQuiz({ ...editingQuiz, title: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg" placeholder="Python Temelleri Quiz" />
			  </div>
			  <div>
				<label className="block text-sm font-medium text-gray-700 mb-2">Varsayılan Süre (sn)</label>
				<input type="number" value={editingQuiz?.defaultTimeLimit || 30} onChange={(e) => setEditingQuiz({ ...editingQuiz, defaultTimeLimit: parseInt(e.target.value) })} className="w-full px-4 py-2 border border-gray-300 rounded-lg" min="10" max="120" />
			  </div>
			</div>
		  </div>
		  <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
			<div className="bg-white rounded-2xl shadow-lg p-6">
			  <h3 className="text-xl font-bold mb-4" style={{ color: marmaraBlue }}>{editingQuestion !== null ? 'Soruyu Düzenle' : 'Yeni Soru Ekle'}</h3>
			  <div className="space-y-4">
				<div>
				  <label className="block text-sm font-medium text-gray-700 mb-2">Soru</label>
				  <textarea value={questionForm.question} onChange={(e) => setQuestionForm({ ...questionForm, question: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg" rows="3" placeholder="Sorunuzu yazın..." />
				</div>
				<div>
				  <label className="block text-sm font-medium text-gray-700 mb-2">Python Kodu (Opsiyonel)</label>
				  <textarea value={questionForm.code} onChange={(e) => setQuestionForm({ ...questionForm, code: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded-lg font-mono text-sm bg-gray-50" rows="4" placeholder="# Python kodu" />
				</div>
				<div>
				  <label className="block text-sm font-medium text-gray-700 mb-2">Seçenekler</label>
				  {questionForm.options.map((option, index) => (
					<div key={index} className="flex items-center gap-2 mb-2">
					  <input type="radio" checked={questionForm.correctAnswer === index} onChange={() => setQuestionForm({ ...questionForm, correctAnswer: index })} className="w-4 h-4" />
					  <input type="text" value={option} onChange={(e) => {
						const newOptions = [...questionForm.options];
						newOptions[index] = e.target.value;
						setQuestionForm({ ...questionForm, options: newOptions });
					  }} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg" placeholder={`Seçenek ${index + 1}`} />
					</div>
				  ))}
				</div>
				<div>
				  <label className="block text-sm font-medium text-gray-700 mb-2">Süre (sn)</label>
				  <input type="number" value={questionForm.timeLimit} onChange={(e) => setQuestionForm({ ...questionForm, timeLimit: parseInt(e.target.value) })} className="w-full px-4 py-2 border border-gray-300 rounded-lg" min="10" max="120" />
				</div>
				{editingQuestion !== null ? (
				  <div className="flex gap-2">
					<button onClick={() => {
					  const updated = [...editingQuiz.questions];
					  updated[editingQuestion] = questionForm;
					  setEditingQuiz({ ...editingQuiz, questions: updated });
					  setEditingQuestion(null);
					  setQuestionForm({ question: '', code: '', options: ['', '', '', ''], correctAnswer: 0, timeLimit: editingQuiz.defaultTimeLimit });
					}} className="flex-1 text-white py-2 rounded-lg font-semibold hover:opacity-90 transition" style={{ backgroundColor: marmaraBlue }}>Güncelle</button>
					<button onClick={() => {
					  setEditingQuestion(null);
					  setQuestionForm({ question: '', code: '', options: ['', '', '', ''], correctAnswer: 0, timeLimit: editingQuiz.defaultTimeLimit });
					}} className="px-6 bg-gray-200 text-gray-700 py-2 rounded-lg font-semibold hover:bg-gray-300 transition">İptal</button>
				  </div>
				) : (
				  <button onClick={addQuestion} className="w-full text-white py-2 rounded-lg font-semibold hover:opacity-90 transition flex items-center justify-center gap-2" style={{ backgroundColor: marmaraBlue }}>
					<Plus className="w-5 h-5" />Soruyu Kaydet
				  </button>
				)}
			  </div>
			</div>
			<div className="bg-white rounded-2xl shadow-lg p-6">
			  <h3 className="text-xl font-bold mb-4" style={{ color: marmaraBlue }}>Sorular ({editingQuiz?.questions.length || 0})</h3>
			  <div className="space-y-3 max-h-[500px] overflow-y-auto">
				{editingQuiz?.questions.length === 0 ? (
				  <p className="text-gray-500 text-center py-8">Henüz soru eklenmedi</p>
				) : (
				  editingQuiz?.questions.map((q, index) => (
					<div key={index} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition">
					  <div className="flex items-start justify-between">
						<div className="flex-1">
						  <div className="font-semibold" style={{ color: marmaraBlue }}>{index + 1}. {q.question}</div>
						  {q.code && <div className="mt-2 bg-gray-900 text-gray-100 rounded p-2 font-mono text-xs"><pre className="whitespace-pre-wrap">{q.code}</pre></div>}
						  <div className="mt-2 text-sm text-gray-600">✓ {q.options[q.correctAnswer]} • {q.timeLimit}s</div>
						</div>
						<div className="flex gap-2 ml-4">
						  <button onClick={() => { setEditingQuestion(index); setQuestionForm(editingQuiz.questions[index]); }} className="p-2 hover:bg-gray-100 rounded" style={{ color: marmaraLightBlue }}>
							<Edit2 className="w-4 h-4" />
						  </button>
						  <button onClick={() => window.confirm('Soru silinecek?') && setEditingQuiz({ ...editingQuiz, questions: editingQuiz.questions.filter((_, i) => i !== index) })} className="p-2 hover:bg-gray-100 rounded text-red-600">
							<Trash2 className="w-4 h-4" />
						  </button>
						</div>
					  </div>
					</div>
				  ))
				)}
			  </div>
			  <div className="flex gap-2 mt-6">
				<button onClick={() => editingQuiz?.title && editingQuiz?.questions.length > 0 ? (setQuizData(editingQuiz), setView('hostDashboard'), alert('Quiz kaydedildi')) : alert('Başlık ve soru gerekli')} className="flex-1 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition flex items-center justify-center gap-2" style={{ backgroundColor: '#00A651' }}>
				  <Save className="w-5 h-5" />Kaydet ve Başlat
				</button>
				<button onClick={() => editingQuiz?.title && editingQuiz?.questions.length > 0 ? downloadFile(JSON.stringify(editingQuiz, null, 2), `${editingQuiz.title.replace(/\s+/g, '_')}.json`, 'application/json') : alert('Başlık ve soru gerekli')} className="flex-1 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition flex items-center justify-center gap-2" style={{ backgroundColor: marmaraLightBlue }}>
				  <Download className="w-5 h-5" />JSON İndir
				</button>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	);
}

if (view === 'playerJoin') {
  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: `linear-gradient(135deg, ${marmaraLightBlue} 0%, #0099E5 100%)` }}>
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-6" style={{ color: marmaraBlue }}>Katılımcı Girişi</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Oyun PIN</label>
            <input 
              type="text" 
              value={gamePin} 
              onChange={(e) => setGamePin(e.target.value)} 
              className="w-full px-4 py-2 border border-gray-300 rounded-lg text-center text-2xl font-bold" 
              placeholder="000000" 
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">İsim</label>
            <input 
              type="text" 
              value={playerName} 
              onChange={(e) => setPlayerName(e.target.value)} 
              className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
              placeholder="Adınız Soyadınız" 
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Öğrenci Numarası</label>
            <input 
              type="text" 
              value={studentId} 
              onChange={(e) => setStudentId(e.target.value)} 
              className="w-full px-4 py-2 border border-gray-300 rounded-lg" 
              placeholder="12345678" 
            />
          </div>
          <div className="flex gap-2">
            <button 
              onClick={() => setView('landing')} 
              className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition"
            >
              Geri
            </button>
            <button 
              onClick={async () => {
                if (!gamePin || !playerName || !studentId) {
                  alert('Tüm alanları doldurun');
                  return;
                }
                try {
                  const response = await axios.post(`${API_URL}/player/join`, {
                    game_pin: gamePin,
                    name: playerName,
                    student_id: studentId
                  });
                  
                  console.log('Join response:', response.data);
                  
                  setQuizData(response.data.quiz_data);
                  setUserId(response.data.user_id);
                  
                  // WebSocket bağlantısı kur
                  //const websocket = new WebSocket(`ws://localhost:8000/ws/${gamePin}/${response.data.user_id}`);
				  const websocket = new WebSocket(`wss://quizappbackend.sababozpolat.com/ws/${gamePin}/${response.data.user_id}`);
                  websocket.onmessage = (event) => {
                    const message = JSON.parse(event.data);
                    console.log('Katılımcı WebSocket mesajı:', message);
                    
                    // YENİ: Katılımcı katıldığında (player için gerekli değil ama tutarlılık için)
				    if (message.type === 'player_joined') {
					  setPlayersList(message.players);
					  setTotalPlayers(message.total_players);
					}
                    
                    if (message.type === 'start_game') {
                      console.log('START_GAME mesajı alındı, countdown başlatılıyor');
                      setCountdown(3);
                    }
                    
                    if (message.type === 'next_question') {
                      setCurrentQuestion(message.question_index);
                      setSelectedAnswer(null);
                      setWaitingForNext(false);
                      setShowLeaderboard(false);
                      setTimeLeft(message.time_limit);
                    }
                    
					if (message.type === 'answer_submitted') {
					  console.log('📊 Leaderboard:', message.leaderboard);
					  setLeaderboard(message.leaderboard);
					  setAnsweredCount(message.answered_count);
					  setTotalPlayers(message.total_players);
					}
                    
                    if (message.type === 'show_results') {
					  setView('results');
					}
                  };
                  setWs(websocket);
                  
                  setIsHost(false);
                  setCurrentQuestion(0);
                  setSelectedAnswer(null);
                  setTimeLeft(response.data.quiz_data.questions[0].timeLimit);
                  setView('lobby');
                } catch (error) {
                  console.error('Join error:', error);
                  alert('Hata: ' + (error.response?.data?.detail || 'Oyuna katılılamadı'));
                }
              }} 
              className="flex-1 text-white py-3 rounded-lg font-semibold hover:opacity-90 transition" 
              style={{ backgroundColor: marmaraLightBlue }}
            >
              Katıl
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

if (view === 'lobby') {
	if (isHost) {
	  return (
		<div className="min-h-screen p-4" style={{ background: `linear-gradient(135deg, ${marmaraBlue} 0%, ${marmaraLightBlue} 100%)` }}>
		  <div className="max-w-4xl mx-auto">
			<div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
			  <h1 className="text-6xl font-bold mb-4" style={{ color: marmaraBlue }}>PIN: {gamePin}</h1>
			  <p className="text-xl text-gray-600 mb-8">Katılımcılar bu kodu kullanarak katılabilir</p>
			  
			  <div className="bg-gray-50 rounded-lg p-6 mb-6">
				<h3 className="text-lg font-semibold mb-4" style={{ color: marmaraBlue }}>
				  Katılımcılar ({playersList.length})
				</h3>
				{playersList.length === 0 ? (
				  <div className="text-gray-600">Katılımcılar bekleniyor...</div>
				) : (
				  <div className="grid grid-cols-2 gap-3 max-h-64 overflow-y-auto">
					{playersList.map((player, index) => (
					  <div key={index} className="bg-white rounded-lg p-3 text-left shadow-sm">
						<div className="font-semibold" style={{ color: marmaraBlue }}>{player.name}</div>
						<div className="text-sm text-gray-600">{player.student_id}</div>
					  </div>
					))}
				  </div>
				)}
			  </div>
			  
			  {/* BUTONLAR - BEYİZ KUTU İÇİNDE */}
			  <div className="flex gap-4">
				<button 
				  onClick={() => {
					const url = `${window.location.origin}?presentation=${gamePin}`;
					window.open(url, '_blank', 'width=1920,height=1080');
				  }}
				  className="flex-1 text-white py-4 rounded-lg font-bold hover:opacity-90 transition flex items-center justify-center gap-2" 
				  style={{ backgroundColor: marmaraLightBlue }}
				>
				  📺 Projeksiyon Ekranını Aç
				</button>
				
				<button 
				  onClick={async () => {
					try {
					  await axios.post(`${API_URL}/game/start-playing`, {
						game_pin: gamePin
					  });
					  setTimeLeft(quizData.questions[0].timeLimit);
					  setCountdown(3);
					} catch (error) {
					  console.error('Oyun başlatma hatası:', error);
					}
				  }}
				  disabled={playersList.length === 0}
				  className="flex-1 text-white py-4 rounded-lg font-bold hover:opacity-90 transition disabled:bg-gray-300 disabled:cursor-not-allowed flex items-center justify-center gap-2" 
				  style={{ backgroundColor: playersList.length > 0 ? '#00A651' : undefined }}
				>
				  <Play className="w-5 h-5" />
				  Oyunu Başlat
				</button>
			  </div>
			</div>
		  </div>
		</div>
	  );
	} else {
    return (
      <div className="min-h-screen p-4" style={{ background: `linear-gradient(135deg, ${marmaraLightBlue} 0%, #0099E5 100%)` }}>
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl p-8 text-center">
            <h1 className="text-4xl font-bold mb-4" style={{ color: marmaraBlue }}>Oyun Başlamak Üzere!</h1>
            <p className="text-xl text-gray-600 mb-8">Host oyunu başlatmasını bekliyor...</p>
            
            <div className="flex items-center justify-center gap-2 text-gray-500 text-4xl">
              <div className="animate-pulse">●</div>
              <div className="animate-pulse" style={{ animationDelay: '0.2s' }}>●</div>
              <div className="animate-pulse" style={{ animationDelay: '0.4s' }}>●</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

if (view === 'game' && quizData) {
  const question = quizData.questions[currentQuestion];

  if (isHost) {

    return (
      <div className="min-h-screen p-4" style={{ background: `linear-gradient(135deg, ${marmaraBlue} 0%, #5B2C91 100%)` }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="lg:col-span-2 bg-white rounded-2xl shadow-2xl p-8">
              <div className="flex justify-between items-center mb-6">
                <div>
                  <div className="text-sm text-gray-600">Soru {currentQuestion + 1} / {quizData.questions.length}</div>
                  <div className="text-2xl font-bold mt-1" style={{ color: marmaraBlue }}>PIN: {gamePin}</div>
                </div>
                <div className="flex items-center gap-2 text-2xl font-bold text-red-600">
                  <Clock className="w-6 h-6" />{timeLeft}s
                </div>
              </div>
              <h2 className="text-2xl font-bold mb-6" style={{ color: marmaraBlue }}>{question.question}</h2>
              {question.code && <div className="bg-gray-900 text-gray-100 rounded-lg p-4 mb-6 font-mono text-sm overflow-x-auto"><pre>{question.code}</pre></div>}
              
              <div className="grid grid-cols-2 gap-3 mb-6">
                {question.options.map((option, index) => {
                  const colors = ['#E74C3C', '#3498DB', '#F39C12', '#2ECC71'];
                  const isCorrect = question.correctAnswer === index;
                  return (
                    <div key={index} className={`p-4 rounded-lg text-white font-semibold ${isCorrect ? 'ring-4 ring-white' : ''}`} style={{ backgroundColor: colors[index] }}>
                      {isCorrect && '✓ '}{option}
                    </div>
                  );
                })}
              </div>

              <button onClick={async () => {
                if (currentQuestion < quizData.questions.length - 1) {
                  const nextIndex = currentQuestion + 1;
                  const nextQuestion = quizData.questions[nextIndex];
                  
                  try {
                    await axios.post(`${API_URL}/game/next-question`, {
                      game_pin: gamePin,
                      question_index: nextIndex,
                      time_limit: nextQuestion.timeLimit
                    });
                  } catch (error) {
                    console.error('Sonraki soru hatası:', error);
                  }
                  
                  setAnsweredCount(0); 
                  setCurrentQuestion(nextIndex);
                  setSelectedAnswer(null);
                  setWaitingForNext(false);
                  setShowLeaderboard(false);
                  setTimeLeft(nextQuestion.timeLimit);
				} else {
				  // Oyun bitti
				  try {
					await axios.post(`${API_URL}/game/show-results`, {
					  game_pin: gamePin
					});
				  } catch (error) {
					console.error('Sonuç hatası:', error);
				  }
				  setView('results');
				}
              }} className="w-full text-white py-3 rounded-lg font-semibold hover:opacity-90 transition" style={{ backgroundColor: marmaraBlue }}>
                {currentQuestion < quizData.questions.length - 1 ? 'Sonraki Soru' : 'Sonuçları Göster'}
              </button>
            </div>

            <div className="bg-white rounded-2xl shadow-2xl p-6">
              <div className="bg-blue-50 rounded-lg p-4 mb-4">
                <div className="text-center">
                  <div className="text-3xl font-bold" style={{ color: marmaraBlue }}>
                    {answeredCount} / {totalPlayers}
                  </div>
                  <div className="text-sm text-gray-600 mt-1">Cevaplayan</div>
                </div>
              </div>
              <h3 className="text-xl font-bold mb-4" style={{ color: marmaraBlue }}>Anlık Durum</h3>
              <div className="space-y-3">
				{leaderboard.slice(0, 10).map((player, index) => (
                  <div key={index} className="flex items-center justify-between bg-gray-50 p-3 rounded-lg">
                    <div className="flex items-center gap-3">
                      <div className="text-xl font-bold text-gray-400">#{index + 1}</div>
                      <div>
                        <div className="font-semibold text-sm" style={{ color: marmaraBlue }}>{player.name}</div>
                        <div className="text-xs text-gray-600">{player.studentId}</div>
                      </div>
                    </div>
                    <div className="text-lg font-bold" style={{ color: marmaraLightBlue }}>{player.score}</div>
                  </div>
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="text-sm text-gray-600">Toplam Katılımcı: {totalPlayers}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  // Host bloğunun bitişi, katılımcı bloğu başlıyor
  return (
    <div className="min-h-screen p-4" style={{ background: `linear-gradient(135deg, ${marmaraBlue} 0%, #5B2C91 100%)` }}>
      <div className="max-w-4xl mx-auto">
        {!waitingForNext ? (
          <div className="bg-white rounded-2xl shadow-2xl p-8">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-3 mb-4 flex items-center justify-between" style={{ borderLeft: `4px solid ${marmaraBlue}` }}>
			  <div>
				<div className="font-semibold" style={{ color: marmaraBlue }}>{playerName}</div>
				<div className="text-xs text-gray-600">{studentId}</div>
			  </div>
			  <div className="text-right">
				<div className="text-sm text-gray-600">Puanınız</div>
				<div className="text-xl font-bold" style={{ color: marmaraLightBlue }}>
				  {leaderboard.find(p => p.user_id === userId)?.score || 0}
				</div>
			  </div>
			</div>
            <div className="flex justify-between items-center mb-6">
              <div className="text-sm text-gray-600">Soru {currentQuestion + 1} / {quizData.questions.length}</div>
              <div className="flex items-center gap-2 text-2xl font-bold text-red-600">
                <Clock className="w-6 h-6" />{timeLeft}s
              </div>
            </div>
            <h2 className="text-2xl font-bold mb-6" style={{ color: marmaraBlue }}>{question.question}</h2>
            {question.code && <div className="bg-gray-900 text-gray-100 rounded-lg p-4 mb-6 font-mono text-sm overflow-x-auto"><pre>{question.code}</pre></div>}
			<div className="grid grid-cols-2 gap-4">
			  {shuffledOptions.map((option, displayIndex) => {
				const colors = ['#E74C3C', '#3498DB', '#F39C12', '#2ECC71'];
				return (
				  <button 
					key={displayIndex}
					onClick={async () => {
					  if (timeLeft > 0 && selectedAnswer === null) {
						setSelectedAnswer(displayIndex);
						
						try {
						  await axios.post(`${API_URL}/answer`, {
							game_pin: gamePin,
							user_id: userId,
							question_index: currentQuestion,
							answer_index: option.originalIndex,
							time_left: timeLeft
						  });
						} catch (error) {
						  console.error('Cevap gönderme hatası:', error);
						}
						
						setTimeout(() => {
						  setWaitingForNext(true);
						  setShowLeaderboard(true);
						}, 500);
					  }
					}}
					disabled={selectedAnswer !== null}
					className="text-white py-6 rounded-lg font-bold text-lg hover:opacity-90 transition disabled:opacity-50"
					style={{ backgroundColor: colors[displayIndex], border: selectedAnswer === displayIndex ? '4px solid white' : 'none' }}
				  >
					{option.text}
				  </button>
				);
			  })}
			</div>
          </div>
		  ) : (
		    <div className="bg-white rounded-2xl shadow-2xl p-8">
		  	<div className="text-center mb-8">
			<div className="text-6xl mb-4">⏱️</div>
			<h2 className="text-2xl font-bold mb-2" style={{ color: marmaraBlue }}>
			  Cevabınız Kaydedildi!
			</h2>
		  	<p className="text-gray-600 mb-6">Diğer katılımcılar bekleniyor...</p>
		  	</div>		  	
			{showLeaderboard && (
			  <div>
				<h3 className="text-xl font-bold mb-4 text-center" style={{ color: marmaraBlue }}>Anlık Sıralama</h3>
				
				{/* Top 5 */}
				<div className="space-y-2 mb-4">
				  {leaderboard.slice(0, 5).map((player, index) => {
					const medals = ['🥇', '🥈', '🥉'];
					return (
					  <div key={player.user_id} className="flex items-center justify-between bg-gray-50 p-3 rounded-lg">
						<div className="flex items-center gap-3">
						  <div className="text-2xl">{medals[index] || `${index + 1}.`}</div>
						  <div>
							<div className="font-semibold text-sm" style={{ color: marmaraBlue }}>{player.name}</div>
						  </div>
						</div>
						<div className="text-lg font-bold" style={{ color: marmaraLightBlue }}>{player.score}</div>
					  </div>
					);
				  })}
				</div>
				
				{/* Divider */}
				<div className="border-t border-gray-300 my-4"></div>
				
				{/* Kendi Sıralaman */}
				<div className="bg-yellow-50 p-4 rounded-lg border-2 border-yellow-400">
				  <div className="text-center text-sm text-gray-600 mb-2">Senin Sıralaman</div>
				  <div className="flex items-center justify-between">
					<div className="flex items-center gap-3">
					  <div className="text-xl font-bold text-yellow-600">
						#{leaderboard.findIndex(p => p.user_id === userId) + 1}
					  </div>
					  <div className="font-semibold" style={{ color: marmaraBlue }}>{playerName}</div>
					</div>
					<div className="text-2xl font-bold" style={{ color: marmaraLightBlue }}>
					  {leaderboard.find(p => p.user_id === userId)?.score || 0}
					</div>
				  </div>
				</div>
				
				<div className="mt-6 flex items-center justify-center gap-2 text-gray-500">
				  <div className="animate-pulse">●</div>
				  <div className="animate-pulse" style={{ animationDelay: '0.2s' }}>●</div>
				  <div className="animate-pulse" style={{ animationDelay: '0.4s' }}>●</div>
				</div>
			  </div>
			)}
		    </div>
		  )}
      </div>
    </div>
  );
}

if (view === 'results') {
  return (
  <div className="min-h-screen p-4" style={{ background: 'linear-gradient(135deg, #F39C12 0%, #E67E22 100%)' }}>
    <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
			<div className="text-center mb-8">
            <Trophy className="w-20 h-20 mx-auto mb-4" style={{ color: '#F39C12' }} />
            <h2 className="text-3xl font-bold" style={{ color: marmaraBlue }}>Quiz Tamamlandı!</h2>
			</div>
			<div className="space-y-4 mb-6">
			  {/* Top 3 Podyum */}
			  <div className="space-y-4 mb-8">
				{leaderboard.slice(0, 3).map((player, index) => {
				  const gradients = [
					'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)', // Altın
					'linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)', // Gümüş
					'linear-gradient(135deg, #CD7F32 0%, #8B4513 100%)'  // Bronz
				  ];
				  const sizes = ['text-6xl', 'text-4xl', 'text-2xl'];
				  const paddings = ['p-8', 'p-6', 'p-4'];
				  const medals = ['🥇', '🥈', '🥉'];
				  
				  return (
					<div 
					  key={index} 
					  className={`rounded-2xl shadow-2xl ${paddings[index]} text-center transform hover:scale-105 transition`}
					  style={{ background: gradients[index] }}
					>
					  <div className="text-6xl mb-2">{medals[index]}</div>
					  <div className="text-white font-bold mb-2" style={{ fontSize: index === 0 ? '2rem' : index === 1 ? '1.5rem' : '1.2rem' }}>
						{player.name}
					  </div>
					  <div className="text-white opacity-90 text-sm mb-3">{player.student_id}</div>
					  <div className={`text-white font-bold ${sizes[index]}`}>
						{player.score}
					  </div>
					  <div className="text-white opacity-75 text-sm mt-1">puan</div>
					</div>
				  );
				})}
			  </div>
			  
			  {/* Divider */}
			  {leaderboard.length > 3 && (
				<div className="border-t-2 border-gray-300 my-6"></div>
			  )}
			  
			  {/* Geri kalan sıralama */}
			  {leaderboard.slice(3).map((player, index) => (
				<div key={index + 3} className="flex items-center justify-between bg-gray-50 p-4 rounded-lg">
				  <div className="flex items-center gap-4">
					<div className="text-2xl font-bold text-gray-400">#{index + 4}</div>
					<div>
					  <div className="font-semibold" style={{ color: marmaraBlue }}>{player.name}</div>
					  <div className="text-sm text-gray-600">{player.student_id}</div>
					</div>
				  </div>
				  <div className="text-2xl font-bold" style={{ color: marmaraLightBlue }}>{player.score}</div>
				</div>
			  ))}
			</div>
			{isHost && (
			  <button 
				onClick={() => {
				  // CSV oluştur
				  const header = 'İsim,Öğrenci No,Puan\n';
				  const rows = leaderboard.map(p => `${p.name},${p.student_id},${p.score}`).join('\n');
				  const csv = header + rows;
				  
				  downloadFile(csv, `quiz_scores_${gamePin}.csv`, 'text/csv');
				}} 
				className="w-full text-white py-3 rounded-lg font-semibold hover:opacity-90 transition flex items-center justify-center gap-2 mb-4" 
				style={{ backgroundColor: '#00A651' }}
			  >
				<Download className="w-5 h-5" />
				Skorları İndir (CSV)
			  </button>
			)}
			<button 
			  onClick={() => {
				// Tüm state'leri resetle
				setView('landing');
				setCodeSent(false);
				setCode('');
				setEmail('');
				setGamePin('');
				setPlayerName('');
				setStudentId('');
				setQuizData(null);
				setCurrentQuestion(0);
				setSelectedAnswer(null);
				setLeaderboard([]);
				setIsHost(false);
				setWaitingForNext(false);
				setShowLeaderboard(false);
				setAnsweredCount(0);
				setTotalPlayers(0);
				setCountdown(null);
				setPlayersList([]);
				if (ws) ws.close();  // WebSocket bağlantısını kapat
				setWs(null);
			  }} 
			  className="w-full bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition"
			>
			  Ana Sayfa
			</button>
        </div>
      </div>
    </div>
  );
}

return null;

};

export default App;
